import React from 'react';

const AdvancedProgram = () => {
  const instructors = [
    {
      name: "Dr. Taranis Carnegie",
      title: "Presidente de la fundacion",
      description: "conocido por explicar los conceptos metafisicos y espirituales mas complejos de forma sencilla y dinamica",
      image: "/instructors/jose-arenas.jpg"
    },
    {
      name: "Dra. Araceli Torrealba",
      title: "Instructora",
      description: "instructora de gran vitalidad, desmenuza los temas esotericos mas complejos con explicaciones sencillas y llanas",
      image: "/instructors/araceli.jpg"
    },
    {
      name: "Dr. Mauricio Romero",
      title: "Instructor",
      description: "experto en Magnetoterapia e Hipnosis, gran trayectoria en el tratamiento de enfermedades con metodos alternativos",
      image: "/instructors/mauricio.jpg"
    },
    {
      name: "Dr. Miguel Angel Bell",
      title: "Instructor",
      description: "experto en temas de sexualidad, hipnosis y herbolaria, amante de la naturaleza",
      image: "/instructors/miguel-angel.jpg"
    },
    {
      name: "Psic. Regina Trinidad",
      title: "Instructora",
      description: "experta en hipnosis clinica y los poderes de la mente. Gran Investigadora y apasionada por las capacidades de la mente",
      image: "/instructors/regina.jpg"
    },
    {
      name: "Dr. Luis Javier Torrealba",
      title: "Instructor",
      description: "experto en aplicacion deportiva de preceptos, Magnetoterapia y mas. Entusiasta de los Autos.",
      image: "/instructors/luis-javier.jpg"
    },
    {
      name: "Dr. Javier Jimenez",
      title: "Instructor",
      description: "Yaqui, Maestro Reikista, ha iniciado a mas de 50,000 personas en reiki en los ultimos 3 años.",
      image: "/instructors/javier-jimenez.jpg"
    },
    {
      name: "Dr. Erick Arreola",
      title: "Instructor",
      description: "experto en psicologia familiar, Maestro Reiki Usui, Karuna y mas. Hipnologo y experto en salud y sexualidad.",
      image: "/instructors/erick-arreola.jpg"
    },
    {
      name: "Instructor Javier Barajas",
      title: "Instructor",
      description: "experto en terapias alternativas y desarrollo personal. Certificado por las Naciones Unidas.",
      image: "/instructors/javier-barajas.jpg"
    },
    {
      name: "Dra. Maura de la Cruz",
      title: "Instructora",
      description: "experta en el cuidado holistico de la salud y el bienestar, Sanadora pranica y conferencista",
      image: "/instructors/maura.jpg"
    }
  ];

  return (
    <div className="min-h-screen bg-[#751fab]">
      {/* Hero Section */}
      <div className="container mx-auto px-4 py-12">
        <div className="text-center">
          <img 
            src="/logofncflor.png"
            alt="Nueva Consciencia Logo"
            className="w-[200px] h-[110px] mx-auto mb-8"
          />
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            PROGRAMA DE FORMACION PREMIUM
          </h1>
          <div className="max-w-3xl mx-auto mb-8">
            <img 
              src="/images/audience.jpg" 
              alt="Programa de Formación"
              className="w-full rounded-lg shadow-lg"
            />
          </div>
          <h2 className="text-2xl text-white mb-8">
            ¿Estás lista para embarcarte en una aventura espiritual sin precedentes?
          </h2>
          <button
            onClick={() => window.open('https://pay.hotmart.com/I92782297L', '_blank')}
            className="bg-white text-[#751fab] font-bold py-4 px-8 rounded-full text-lg hover:bg-purple-50 transition-colors inline-flex items-center"
          >
            Inscribirse
            <span className="ml-2">→</span>
          </button>
        </div>
      </div>

      {/* Instructors Section */}
      <div className="bg-[#751fab] py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-white text-center mb-12">
            Tus Instructores...
          </h2>
          <p className="text-white text-center max-w-4xl mx-auto mb-12">
            10 maestros excepcionales, verdaderos referentes en sus respectivas áreas de especialización. Este equipo de
            élite te guiará en un viaje transformador que te llevará a explorar las profundidades de tu ser y a descubrir
            nuevos horizontes en tu camino de crecimiento personal.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {instructors.map((instructor, index) => (
              <div key={index} className="bg-[#ad4bed] rounded-lg overflow-hidden">
                <img 
                  src={instructor.image}
                  alt={instructor.name}
                  className="w-full h-[350px] object-cover"
                />
                <div className="p-6">
                  <h3 className="text-white font-bold text-xl mb-2">{instructor.name}</h3>
                  <p className="text-white/80 mb-2">{instructor.title}</p>
                  <p className="text-white">{instructor.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Program Description */}
      <div className="bg-[#751fab] py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-white mb-8">
              ¿En que consiste el programa de formacion Premium?
            </h2>
            <div className="space-y-6 text-white">
              <p>
                La formacion consiste en 8 Clases Mensuales a razon de 2 semanales, cada clase es impartida por un instructor diferente,
                cada uno de estos instructores ha alcanzado en su campo de especialidad un Renombre y trayectoria de clase mundial, y
                está listo para compartir contigo sus conocimientos, técnicas revolucionarias y sabiduría ancestral. Su pasión, carisma y
                dedicación te inspirarán a superar tus límites y a alcanzar niveles de conciencia que jamás imaginaste posibles.
              </p>
              <p>
                No se trata de una simple clase, sino de una experiencia inmersiva que te transportará a nuevas dimensiones espirituales.
              </p>
              <p>
                Estos 10 maestros te acompañarán en cada paso, brindándote las herramientas y el apoyo necesarios para que puedas
                descubrir tu verdadero potencial y transformar tu vida desde la raíz.
              </p>
              <p className="font-semibold">
                ¿Estás listo para embarcarte en este viaje único e irrepetible? ¿Quieres ser parte de un selecto grupo de personas que
                tendrán el privilegio de aprender de los mejores maestros espirituales de America Latina? No dejes pasar esta
                oportunidad extraordinaria. ¡Únete ahora y prepárate para vivir una experiencia que cambiará tu vida para siempre!
              </p>
            </div>
            <button
              onClick={() => window.open('https://pay.hotmart.com/I92782297L', '_blank')}
              className="mt-12 bg-white text-[#751fab] font-bold py-4 px-8 rounded-full text-lg hover:bg-purple-50 transition-colors inline-flex items-center"
            >
              Inscribirse
              <span className="ml-2">→</span>
            </button>
          </div>
        </div>
      </div>

      {/* Social Media Links */}
      <div className="bg-[#751fab] py-8">
        <div className="container mx-auto px-4 flex justify-center space-x-4">
          <a href="#" className="text-white hover:text-purple-200">
            <span className="sr-only">Facebook</span>
            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </a>
          <a href="#" className="text-white hover:text-purple-200">
            <span className="sr-only">Instagram</span>
            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdvancedProgram;